module.exports = __webpack_public_path__ + "img/yastinjimenez.c76b6e7f.jpg";